module.exports = __webpack_public_path__ + "static/img/chat-icons-off.cebcee4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chat-icons-off.png
// module id = 151
// module chunks = 1